import Stack from '@mui/material/Stack'
import React from 'react'
import CardView from './components/CardView'
import { ValueNarrative, ValueNarrativeCategory } from '../../../../queries/useGetValueNarrativesQuery'

type CardsViewTabProps = {
    data: ValueNarrativeCategory[]
    handleSelectNarrative: (categoryId: string, valueNarrativeId: string) => void
    isReorderModeActive?: boolean
    onReorderCategoryNarratives?: (categoryId: string, newNarratives: ValueNarrative[]) => void
}

const CardsViewTab = ({
    data,
    handleSelectNarrative,
    isReorderModeActive,
    onReorderCategoryNarratives,
}: CardsViewTabProps) => {
    return (
        <Stack gap={1} direction="column">
            {data.map((category) => {
                const isCategoryReorderable = !category.narratives.some((narrative) => !!narrative.archived)

                return (
                    <CardView
                        key={category._id}
                        category={category}
                        handleSelectNarrative={handleSelectNarrative}
                        isReorderModeActive={!!isReorderModeActive && isCategoryReorderable}
                        onReorderNarratives={(newNarratives) =>
                            onReorderCategoryNarratives?.(category._id, newNarratives)
                        }
                    />
                )
            })}
        </Stack>
    )
}

export default CardsViewTab
